import { render, staticRenderFns } from "./WsExamsShiftsList.vue?vue&type=template&id=29ab4bc9"
import script from "./WsExamsShiftsList.vue?vue&type=script&lang=js"
export * from "./WsExamsShiftsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports